// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-WDrg2R{flex-direction:row;margin-bottom:8px;padding:0 1px;display:flex}.message-selectable-AlqB45{margin-left:29px}.checkbox-tIvHxO{margin-top:10px;margin-right:12px}.background-mode-checkbox-RvPOYr .semi-checkbox-inner-display{box-shadow:inset 0 0 0 1px #fff}.onboarding-message-content-QN7VCT{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;word-break:break-word}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `message-WDrg2R`,
	"message-selectable": `message-selectable-AlqB45`,
	"messageSelectable": `message-selectable-AlqB45`,
	"checkbox": `checkbox-tIvHxO`,
	"background-mode-checkbox": `background-mode-checkbox-RvPOYr`,
	"backgroundModeCheckbox": `background-mode-checkbox-RvPOYr`,
	"onboarding-message-content": `onboarding-message-content-QN7VCT`,
	"onboardingMessageContent": `onboarding-message-content-QN7VCT`
};
export default ___CSS_LOADER_EXPORT___;
